// Add your custom JS here.
jQuery(document).ready(function(){
    // Target the parent menu item by class name and add a click event
    jQuery('.lsm-menu-lawn').on('click', function(){
        // Replace 'your-link-url' with the URL you want to navigate to
        window.location.href = '/services/lawn-care/';
    });
});